const dictationUsedByConversationId = new Set<string>()

export function markDictationUsed(conversationId: string): void {
  dictationUsedByConversationId.add(conversationId)
}

export function consumeDictationUsed(conversationId: string): boolean {
  const used = dictationUsedByConversationId.has(conversationId)
  dictationUsedByConversationId.delete(conversationId)
  return used
}

export function clearDictationUsed(conversationId: string): void {
  dictationUsedByConversationId.delete(conversationId)
}

export function clearDictationUsedMarks(): void {
  dictationUsedByConversationId.clear()
}
